import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
/* eslint-disable no-undef */
import Vue from 'vue';
import Vuex from 'vuex';
import VueCookie from 'vue-cookies';
import jslinq from 'jslinq';
Vue.use(Vuex);
Vue.use(VueCookie);
class AppState {
  constructor() {
    this.profileOpen = false;
    this.currentTab = 'tab-cart'; //tabella aperta del profilo ;
    this.coloreMetalloAste = 'GUN';
    this.coloreAste = "";
    this.lenteSx = null;
    this.lenteDx = null;
    this.tintaUnita = true;
    this.filteredTemples = [];
    this.marchio = '';
    this.btActive = false;
    this.itemsLoaded = false;
    this.currentLine = '';
  }
}
export default new Vuex.Store({
  state: new AppState(),
  mutations: {
    setMarchio(state, marchio) {
      state.marchio = marchio;
    },
    setCurrentLine(state, subline) {
      state.currentLine = subline;
    },
    setBtActive(state, btActive) {
      state.btActive = btActive;
    },
    setTintaUnita(state, n) {
      state.tintaUnita = n;
    },
    setItemsLoaded(state, itemsLoaded) {
      state.itemsLoaded = itemsLoaded;
    },
    setFilteredTemples(state, filteredTemples) {
      state.filteredTemples = filteredTemples;
    },
    setTemplesMetalColor(state, metalColor) {
      state.coloreMetalloAste = metalColor;
    },
    /**
     * Questa funzionae ripristina una configurazione passata come parametro
     * @param {object} state store
     * @param {object} configuration configurazione da ripristinare
     */
    restoreConfigurationObject(state, configuration) {
      state.configurator.frontale = configuration.frontale; //modello frontale
      state.configurator.calibro = configuration.calibro;
      state.configurator.naso = configuration.naso;
      state.configurator.asianFitting = configuration.asianFitting;
      state.configurator.colore = configuration.colore;
      state.configurator.finitura = configuration.finitura;
      state.configurator.coloreAste = configuration.coloreAste;
      state.configurator.coloreMetalloAste = configuration.ColoreMetalloAste;
      state.configurator.misuraAste = configuration.misuraAste;
      state.configurator.frontali.name = configuration.nome;
      state.configurator.frontali.nameColor = configuration.coloreNome;
      state.configurator.note = configuration.note;
    },
    resetLentiVista(state) {
      state.configurator.lenteVistaDx = null;
      state.configurator.lenteVistaSx = null;
      // state.configurator.lenti!.sferaDx = 0;
      // state.configurator.lenti!.sferaSx = 0;
      // state.configurator.lenti!.cilindroDx = 0;
      // state.configurator.lenti!.cilindroSx = 0;
      // state.configurator.lenti!.asseDx = 0;
      // state.configurator.lenti!.asseSx = 0;
      // state.configurator.lenti!.semiDistDx = 0;
      // state.configurator.lenti!.semiDistSx = 0;
      // state.configurator.lenti!.altPupDx = 0;
      // state.configurator.lenti!.altPupSx = 0;
      // state.configurator.lenti!.addDx = 0;
      // state.configurator.lenti!.addSx = 0;
    },
    resetConfiguration(state, {
      forma,
      colore,
      coloreAste,
      sizeDescription
    }) {
      if (sizeDescription && state.configurator.frontali !== undefined) {
        const regularSize = state.configurator.frontali.itemsSizes.filter(size => {
          return size.size_description == sizeDescription && size.U_THE_MODELLO == forma;
        });
        state.configurator.calibro = regularSize[0].size_eye;
        state.configurator.naso = regularSize[0].size_bridge;
      } else {
        state.configurator.calibro = '';
        state.configurator.naso = '';
      }
      state.configurator.asianFitting = false;
      if (state.configurator.frontali != undefined) {
        var _state$configurator$f;
        state.configurator.colore = (_state$configurator$f = state.configurator.frontali.colors.find(col => {
          return col.U_THE_COLORE == (colore ? colore : "EP0001");
        })) !== null && _state$configurator$f !== void 0 ? _state$configurator$f : null;
      } else {
        state.configurator.colore = null;
      }
      state.configurator.finitura = "S";
      state.configurator.misuraAste = '145';
      if (state.configurator.aste != undefined) {
        var _state$configurator$a;
        state.configurator.coloreAste = (_state$configurator$a = state.configurator.aste.allColors.find(col => {
          return col.U_THE_COLORE == (coloreAste ? coloreAste : "PL0001") && col.U_THE_LUNGASTA == state.configurator.misuraAste;
        })) !== null && _state$configurator$a !== void 0 ? _state$configurator$a : null;
      }
      state.configurator.coloreMetalloAste = "";
      state.configurator.finituraAste = "S";
      // TODO: verificare come resettare le variabili di seguito
      if (state.configurator.frontali) {
        state.configurator.frontali.name = "";
        state.configurator.frontali.nameFont = "Batang";
        state.configurator.frontali.nameColor = "";
      }
      if (state.configurator.aste) {
        state.configurator.aste.extSxName = '';
        state.configurator.aste.extSxNameColor = '';
        state.configurator.aste.extSxNameFont = 'Batang';
        state.configurator.aste.intSxName = '';
        state.configurator.aste.intSxNameColor = '';
        state.configurator.aste.intSxNameFont = 'Batang';
        state.configurator.aste.extDxName = '';
        state.configurator.aste.extDxNameColor = '';
        state.configurator.aste.extDxNameFont = 'Batang';
        state.configurator.aste.intDxName = '';
        state.configurator.aste.intDxNameColor = '';
        state.configurator.aste.intDxNameFont = 'Batang';
      }
      state.configurator.note = "";
      if (forma && state.configurator.frontali != undefined) {
        if (forma.indexOf('S') >= 0 && state.configurator.glassType == 'V') {
          forma = forma.replace('S', '');
          const f = jslinq(state.configurator.frontali.items);
          const fd = f.firstOrDefault(front => {
            return front.U_THE_MODELLO == forma;
          });
          // this.setFrontale(fd)
          state.configurator.frontale = fd;
        } else if (forma.indexOf('S') >= 0 && state.configurator.glassType == 'S') {
          const f = jslinq(state.configurator.frontali.items);
          const fd = f.firstOrDefault(front => {
            return front.U_THE_MODELLO == forma;
          });
          state.configurator.frontale = fd;
        }
      } /* else {
        state.frontale = state.frontale;
        }*/
    },
    setLenteSx(state, l) {
      state.lenteSx = l;
    },
    setLenteDx(state, l) {
      state.lenteDx = l;
    },
    setProfileOpen: (state, po) => {
      state.profileOpen = po;
    },
    setCurrentTab: (state, ct) => {
      state.currentTab = ct;
    },
    setTemplesColor(state, tc) {
      state.coloreAste = tc;
    }
  },
  actions: {},
  getters: {
    marchio: state => {
      return state.marchio;
    },
    btActive: state => {
      return state.btActive;
    },
    profileOpen: state => {
      return state.profileOpen;
    },
    currentTab: state => {
      return state.currentTab;
    },
    canOrderColorSample: (state, getters) => {
      return state.configurator.colore != null && !getters.userIsGuest;
    },
    coloreAste: state => {
      return state.configurator.coloreAste;
    }
  }
});